<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :icon="icon"
    sizeClass='modal-med'
    :submitting="submitting"
    :submitTitle="submitTitle"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="textEntryForm" :labelColumnSize="3">
      <FormUploadDropTarget @filesDropped="$refs.documentUpload.filesDroppedFromTarget($event)">
        <NotificationBar type="warning" v-if="warning">
          <NotificationBarTitle><span v-html="warning" /></NotificationBarTitle>
        </NotificationBar>
        <p v-if="notes">{{notes}}</p>
        <FormRow v-show="showQuantity" :label="quantityLabel" :suffix="quantitySuffix">
          <FormInputText ref="quantityEntry" type="number" v-model="quantity" :note="quantityNote" />
        </FormRow>
        <FormRow :label="textLabel">
          <FormInputTextArea ref="textEntryArea" v-model="text" :placeholder="placeholder" :field="textField" />
        </FormRow>
        <FormRow label="Attachments" v-show="showAttachments">
          <FormUpload ref="documentUpload" v-model="uploadFileList" field="uploadFileList" />
        </FormRow>
      </FormUploadDropTarget>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: "OrderActionDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    title: String,
    icon: String,
    textLabel: String,
    placeholder: String,
    textField: String,
    notes: String,
    warning: String,
    showQuantity: {
      type: Boolean,
      default: false
    },
    showAttachments: {
      type: Boolean,
      default: true
    },
    quantityLabel: String,
    quantitySuffix: String,
    quantityNote: String,
    submitTitle: String,
    submitPromise: Function
  },
  data() {
    return {
      submitting: false,
      text: '',
      quantity: 0,
      uploadFileList: [],
      textEntryForm: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.showQuantity)
        this.$refs.quantityEntry.focus()
      else
        this.$refs.textEntryArea.focus()
    })
  },
  computed: {
  },
  methods: {
    show(params) {
      this.textEntryForm = {}
      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      if(!this.$refs.documentUpload.validateUploadsComplete())
        return
        
      this.submitting = true
      this.textEntryForm = {}

      this.submitPromise({ quantity: this.quantity, text: this.text, uploadFileList: this.uploadFileList })
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.textEntryForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>